import { createContext, type ReactNode, useContext, useState } from 'react';

const EnvironmentModeContext = createContext({
  isDevMode: true,
  toggleDevMode: () => {},
});

export const EnvironmentModeContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isDevMode, setIsDevMode] = useState(true);

  function toggleDevMode() {
    setIsDevMode(!isDevMode);
  }

  return (
    <EnvironmentModeContext.Provider value={{ isDevMode, toggleDevMode }}>
      {children}
    </EnvironmentModeContext.Provider>
  );
};

export const useEnvironmentModeContext = () =>
  useContext(EnvironmentModeContext);
